import { Pipe, PipeTransform } from '@angular/core';
import { PhotoCollectionDto } from '../../../models/trofaco/photoCollectionDto';
import { SafeUrl } from '@angular/platform-browser';

@Pipe({
    name: 'headerPhoto'
})
export class HeaderPhotoPipe implements PipeTransform {

    transform(collection: PhotoCollectionDto): string | SafeUrl {
        let photo = collection.photos.find(p => p.id == collection.thumbnailPhotoId);
        if (!photo) return undefined;
        return photo.thumbnailUrl;
    }

}
